import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  List,
  ListItemButton,
  ListItemText,
  Popover,
} from '@mui/material';
import { FilterChip } from '../../../utils/catalog/catalogFilters';

interface Props {
  chips: FilterChip[];
  onToggleValue: (key: string, label: string) => void;
  onClear: (key: string) => void;
}

export default function FilterChips({ chips, onToggleValue, onClear }: Props) {
  const [openKey, setOpenKey] = React.useState<string | null>(null);
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
  const open = chips.find(c => c.key === openKey);

  if (!chips.length) return null;

  return (
    <Box display="flex" flexWrap="wrap" gap={0.75}>
      {chips.map(chip => {
        const selectedCount = chip.values.filter(v => v.selected).length;
        return (
          <Chip
            key={chip.key}
            label={
              selectedCount ? `${chip.label} · ${selectedCount}` : chip.label
            }
            color={selectedCount ? 'primary' : 'default'}
            variant={selectedCount ? 'filled' : 'outlined'}
            onClick={e => {
              setAnchor(e.currentTarget);
              setOpenKey(chip.key);
            }}
            onDelete={selectedCount ? () => onClear(chip.key) : undefined}
          />
        );
      })}
      <Popover
        open={!!open}
        anchorEl={anchor}
        onClose={() => setOpenKey(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <List dense sx={{ minWidth: 220, maxHeight: 320, overflowY: 'auto' }}>
          {open?.values.map(value => (
            <ListItemButton
              key={value.label}
              dense
              onClick={() => onToggleValue(open.key, value.label)}>
              <Checkbox
                edge="start"
                size="small"
                checked={value.selected}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText
                primary={value.label}
                secondary={value.count}
                primaryTypographyProps={{ variant: 'body2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 1,
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </Box>
  );
}
